export default __webpack_public_path__ + "static/media/course_cart.7c2cf27b.svg";